import { IOrder } from '.';

const formatDate = (date: string) => {
  if (date === null) return '-';
  if (date === '') return '-';

  if (date.toString() === '0001-01-01T00:00:00') {
    return '-';
  }
  if (date) {
    return date.split('T')[0].split('-').reverse().join('/');
  }
  return '-';
};

export const shapeOrders = (orders: IOrder[]) => {
  return orders?.map((order) => {
    return {
      ...order,
      issueDate: formatDate(order.issueDate),
      deliveryDate: formatDate(order.deliveryDate),
      scheduleDate: formatDate(order.scheduleDate),
      deliveryDateOrigin: formatDate(order.deliveryDateOrigin)
    };
  });
};
